// extracted by mini-css-extract-plugin
export default {"keepDoubleSpaces":"activityCell_keepDoubleSpaces__4DMAk"};